import { useState } from "react";
import Button from "@mui/material/Button/Button";
import Divider from '@mui/material/Divider';
import { Box, FormGroup, Stack, TextField } from "@mui/material";
import { IPageProps } from "../../Models";
import { UserApiService } from "../../Services/UserService";
import { UserCognitoStatus, UserCognitoStatusToString } from "../../Models/UserCognitoStatus";


function UsersAccount(props: IPageProps) {

  const [status, setStatus] = useState<UserCognitoStatus | null>(null)
  const [email, setEmail] = useState<string>("");

  const userApiService = new UserApiService();

  const resendTemporaryPassword = async () => {
    props.handleAlertShow("success", "");
    props.setIsLoading(true);
    var res = null;
    try {
      res = await userApiService.ResendTemporaryPassword(email);
      props.handleAlertShow("success", `Successfully sent temporary password to ${email}`);
    } catch (error: any) {
      props.handleAlertShow("error", error.message);
    } finally {
      props.setIsLoading(false);
    }
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    props.handleAlertShow("success", "");
    setStatus(null)
    props.setIsLoading(true);

    if (!email.trim()) {
      props.setIsLoading(false);
      props.handleAlertShow("error", "No email address provided");
      setStatus(null);
      return;
    }

    try {
      var res = await userApiService.GetUserStatus(email);
      setStatus(res.data)
    } catch (error: any) {
      props.handleAlertShow("error", error.message);
      setStatus(null)
    } finally {
      props.setIsLoading(false);
    }
  };

  return (
    <>
      <Box marginBottom={4} fontSize={22} >
        {"User Account Status"}
      </Box>

      <Stack marginTop={2} spacing={6} key="box1">
        <Box component="form" onSubmit={handleSubmit}>
          <FormGroup
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
            }}
          >
            <TextField
              id="userEmail"
              label="User email"
              variant="outlined"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button
              key="check"
              variant="contained"
              sx={{ margin: "10px" }}
              type="submit"
            >
              Check
            </Button>
          </FormGroup>
        </Box>

        <Divider></Divider>

        {
          status !== null &&

          <Stack spacing={2} >
            <Box sx={{
              objectFit: 'scale-down',
              color: 'text.primary',
              fontSize: 22,
              fontWeight: 'medium',
            }}> 
                {"Response"}
            </Box>

            <Stack sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: 2,
            }}
            >
              <Box sx={{ fontStyle: 'italic', padding: 1 }} >
                {"Status:"}
              </Box>

              <Box sx={{ padding: 1, borderRadius: 5, }} >
                { UserCognitoStatusToString(status) }
              </Box>

              {
                status == UserCognitoStatus.FORCE_CHANGE_PASSWORD &&
                <Button
                  key="box3"
                  variant="contained"
                  onClick={resendTemporaryPassword}
                  sx={{ marginLeft : 6 }}
                >
                  Send temporary password
                </Button>
              }
            </Stack>
          </Stack>
        }

      </Stack>
    </>
  );
}

export default UsersAccount;

